import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_GROUP = 'add group'
export const NAME = 'name'
export const CURRENCY = 'currency'
export const CARDS = 'cards'
export const ADD_RATE_CARDS = 'add rate cards'
export const MAX = 'max'
export const MIN = 'min'
export const VALID_MAX = 'valid max'
export const RATE_CARDS = 'rate cards'
export const SAVE_RATE_CARDS = 'save rate cards'
export const REQUIRED_FIELDS = 'required fields'
export const CHANGES_SAVED = 'changes saved'
export const GROUP_REGISTERED = 'group registered'

export default {
  [PORTUGUESE]: {
    [ADD_GROUP]: 'Adicionar Grupo',
    [NAME]: 'Nome',
    [CURRENCY]: 'Moeda',
    [CARDS]: 'Tabelas',
    [ADD_RATE_CARDS]: 'Tabelas de Preços',
    [MAX]: 'Máx.',
    [MIN]: 'Mín.',
    [VALID_MAX]: 'Max deve ser maior que "Mín"',
    [RATE_CARDS]: 'Tabelas de Preços',
    [SAVE_RATE_CARDS]: 'Salvar tabelas de preços',
    [REQUIRED_FIELDS]: 'Por favor preencha os campos obrigatórios',
    [CHANGES_SAVED]: 'As mudanças foram salvas',
    [GROUP_REGISTERED]: 'Grupo registrado com sucesso',
  },

  [ENGLISH]: {
    [ADD_GROUP]: 'Add Group',
    [NAME]: 'Name',
    [CURRENCY]: 'Currency',
    [CARDS]: 'Cards',
    [ADD_RATE_CARDS]: 'Add Rate Cards',
    [MAX]: 'Max',
    [MIN]: 'Min',
    [VALID_MAX]: 'Max must be greater than "Min"',
    [RATE_CARDS]: 'Rate Cards',
    [SAVE_RATE_CARDS]: 'Save Rate Cards',
    [REQUIRED_FIELDS]: 'Please fill in the required fields',
    [CHANGES_SAVED]: 'Changes have been saved',
    [GROUP_REGISTERED]: 'Group registered successfully',
  },

  [SPANISH]: {
    [ADD_GROUP]: 'Añadir Grupo',
    [NAME]: 'Nombre',
    [CURRENCY]: 'la Moneda',
    [CARDS]: 'Tarjetas',
    [ADD_RATE_CARDS]: 'Agregar Tarjetas de Tarifas',
    [MAX]: 'Máx.',
    [MIN]: 'Mín.',
    [VALID_MAX]: 'Max debe ser mayor que "Mín"',
    [RATE_CARDS]: 'Tarjetas de Tarifas',
    [SAVE_RATE_CARDS]: 'Guardar tarjetas de tarifas',
    [REQUIRED_FIELDS]: 'Por favor llene los campos requeridos',
    [CHANGES_SAVED]: 'Los cambios han sido guardados',
    [GROUP_REGISTERED]: 'Grupo registrado con éxito',
  },
}
